import { ref } from 'vue'

export function useToggle(defaultValue = false) {
  const isActive = ref(defaultValue)

  const toggleValue = () => {
    isActive.value = !isActive.value
  }

  const activate = () => {
    isActive.value = true
  }

  const deactivate = () => {
    isActive.value = false
  }

  return [isActive, toggleValue, activate, deactivate]
}
